import Router from '../Router';
import { IAppProps } from '@interfaces/App.interface';
import { Grid, GridContainerFullHeight } from '@ts/storybook';
import TBreadcrumbs from '@components/Outputs/Breadcrumbs';

interface IBodyProps extends IAppProps {}

const Body = (props: IBodyProps) => {
  return (
    <GridContainerFullHeight id="grid-body">
      <Grid container size="auto" className="w-full">
        <TBreadcrumbs {...props} />
      </Grid>
      <Grid container id="main-column" size="grow" className="flex-1 overflow-y-auto w-full">
        <Router {...props} />
      </Grid>
    </GridContainerFullHeight>
  );
};

export default Body;
